"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HIRE_PLANS_NEEDED_MESSAGE = exports.saveHirePlansSchema = void 0;
exports.hirePlansState = hirePlansState;
exports.hirePlansProblem = hirePlansProblem;
const zod_1 = require("zod");
const hiring_templates_1 = require("./hiring-templates");
// ADR 0083 (owner 2026-11-01 Q5 a, Q8 a): each hire's own 30-day and 90-day plans. The line manager writes them after the offer
// is accepted (N-103 opens this page; with Offers off, once the person is Selected), starting from what the request and the job
// had. HR reaches the same page from the job's Selected step. Both must be complete before the hire can be marked as joined.
exports.saveHirePlansSchema = zod_1.z.object({
    /** 0 while the plans were never saved. */
    version: zod_1.z.number().int().nonnegative(),
    plan30: hiring_templates_1.plan30Schema,
    plan90: hiring_templates_1.plan90Schema,
});
exports.HIRE_PLANS_NEEDED_MESSAGE = 'Write the 30-day and 90-day plans first: the line manager fills them in on this hire’s plans page.';
function hirePlansState(plan30, plan90, managesPeople) {
    const first = (0, hiring_templates_1.plan30Progress)(plan30, managesPeople);
    const second = (0, hiring_templates_1.plan90Progress)(plan90, managesPeople);
    return { plan30: first, plan90: second, isComplete: first.isComplete && second.isComplete };
}
/** Why joining can't be confirmed yet because of the plans; null when both are complete. Never-saved plans are not complete. */
function hirePlansProblem(plans, managesPeople) {
    if (plans === null)
        return exports.HIRE_PLANS_NEEDED_MESSAGE;
    return hirePlansState(plans.plan30, plans.plan90, managesPeople).isComplete ? null : exports.HIRE_PLANS_NEEDED_MESSAGE;
}
//# sourceMappingURL=hire-plans.js.map